import React from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import AnalysisTabs from "examples/Tabs/AnalysisTabs";

function CostAnalysis() {
  return (
    <DashboardLayout>
      <AnalysisTabs />
    </DashboardLayout>
  );
}

export default CostAnalysis;